// src/store/store.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/login/loginSlice';
import signupReducer from '../features/signup/signupSlice';
import { userReducer } from 'features/user/userSlice';
import uiReducer from './uiSlice';
import categoryReducer from '../features/category/categorySlice';
import alertReducer from './alertSlice';
import adminReducer from '../features/admin/adminSlice';
import superAdminReducer from '../features/super-admin/superAdminSlice';
import stockReducer from '../features/stock/stockSlice';
import supplierReducer from '../features/suppliers/supplierSlice';
import billingReducer from '../features/billing/billingSlice';
import billingV2Reducer from '../features/billing-v2/billingV2Slice';
import storeReducer from '../features/store/storeSlice';
import transferReducer from '../features/transfer/transferSlice';
import menuReducer from '../features/menu/menuSlice';
import demandReducer from '../features/demand/demandSlice';
import stockLogsReducer from '../features/stock-logs/stockLogsSlice';
import expenseReducer from '../features/expenses/expenseSlice';
import dashboardReducer from '../features/dashboard/dashboardSlice';
import menuBillingReducer from '../features/menu-billing/menuBillingSlice';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    auth: authReducer,
    signup: signupReducer,
    user: userReducer,
    category: categoryReducer,
    alert: alertReducer,
    admin: adminReducer,
    superAdmin: superAdminReducer,
    stock: stockReducer,
    suppliers: supplierReducer,
    billing: billingReducer,
    billingV2: billingV2Reducer,
    store: storeReducer,
    transfer: transferReducer,
    menu: menuReducer,
    demand: demandReducer,
    stockLogs: stockLogsReducer,
    expenses: expenseReducer,
    dashboard: dashboardReducer,
    menuBilling: menuBillingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
